<template>
<div>
	<h1> This is test </h1>
	<h4> netikras testas cia</h4>
</div>
</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "service",
				title: "IT Team Extension"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
